/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Carrier/view.blocks to change it.
import * as fromData from 'Simple/Data'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Carrier({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/Profile/Content/Insurance/AddAction/Content/Content/SearchTable/Content/Result/Carrier"
  
}) {
let insuranceInsuranceCompanyCarrierNameValueData = fromData.useDataValue({ viewPath,
context: 'insurance',
path: 'insurance_company.carrier_name',
})
  return (<React.Fragment
>
<div
  data-testid="Carrier.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="insurance.insurance_company.carrier_name"
 text={insuranceInsuranceCompanyCarrierNameValueData}
/>
</div>
{children}
</React.Fragment>)
}